// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3EmjL","detailsBorder":"styles_detailsBorder__VN_zu"};